import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { Checkbox, Tooltip } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import CommonDynamicTableNew from "../../../../common/components/CommonTable/CommonDynamicTableNew";
import InputField from "../../../../common/components/FormFields/InputField";
import SearchDropdown from "../../../../common/components/FormFields/searchDropdown";
import { fetchOtServices } from "../../../services/otDetailsServices/OtDetailsServices";
import { OtDetailsContext } from "./OtDetails";
import { warningAlert } from "../../../../common/components/Toasts/CustomToasts";
import InputArea from "../../../../common/components/FormFields/InputArea";
import CheckBoxField from "../../../../common/components/FormFields/CheckBoxField";

const Instruments = () => {
  const { instrumentsData, setInstrumentsData, PatientTypeRadio, patientInfo } =
    useContext(OtDetailsContext);

  //
  const [searchString, setSearchString] = useState("");
  const [serviceInfo, setServiceInfo] = useState();

  const {
    control,
    watch,
    setValue,
    setError,
    clearErrors,
    register,
    formState: { errors },
  } = useFormContext();

  // arr Duplication Check
  let token = JSON.parse(localStorage.getItem("userInfo"));
  let unitId = token.unitId;

  useEffect(() => {
    if (searchString !== "") {
      const otServiceObj = {
        applicableTo: PatientTypeRadio,
        classId: patientInfo ? patientInfo?.classId : 0,
        description: searchString !== "" ? searchString : "",
        groupId: 0,
        isConcessionService: 0,
        isEmergency: false,
        isExternal: false,
        isFree: 0,
        serviceCode: "%",
        tariffId: patientInfo ? patientInfo?.tariffId : 0,
        unitId: unitId,
      };

      fetchOtServices(otServiceObj)
        .then((response) => response.data)
        .then((res) => {
          setServiceInfo(res.result);
        });
    }
  }, [searchString]);

  //add Doctors List

  let searchedServiceData = watch("searchService");
  let qty = watch("instServiceQty");
  let getSelectedServiceRate = watch("instServiceRate");
  let getDoctorOwnInstrument = watch("ownInstrument");

  const addOtServices = () => {
    if (searchedServiceData !== null) {
      let serviceListData = {
        ServiceId: Number(searchedServiceData.ServiceId),
        "Service Name": searchedServiceData.label,
        Rate: Number(getSelectedServiceRate),
        Qty: Number(qty),
        TotalAmt: Number(getSelectedServiceRate) * Number(qty),
        aneasAmount: "",
        NetAmount: searchedServiceData.NetAmt,
        TariffId: searchedServiceData.TariffId,
        otOtherDetailsId: 0,
        isDelete: false,
        ownInstrument: getDoctorOwnInstrument,
        isNew: true,
      };

      let isItemAlreadyExist = false;
      isItemAlreadyExist = instrumentsData.some(
        (item) =>
          !item.isDelete && item.ServiceId === serviceListData.ServiceId,
      );

      if (isItemAlreadyExist) {
        warningAlert("Service Already Exists...");
      } else {
        setInstrumentsData((prev) => [...prev, serviceListData]);
      }

      setValue("searchService", null, { shouldValidate: true });
      setValue("instServiceQty", "", { shouldValidate: true });
      setValue("instServiceRate", "", { shouldValidate: true });
      setValue("ownInstrument", false, { shouldValidate: true });
    }
  };

  const renderActions = (row, index) => {
    return (
      <>
        <Tooltip title="Delete">
          <button
            type="button"
            className="text-red-500 mr-3"
            onClick={() => {
              setInstrumentsData((prevData) => {
                if (row?.isNew === false) {
                  return prevData.map((item) =>
                    item.ServiceId === row.ServiceId
                      ? { ...item, isDelete: true }
                      : item,
                  );
                }

                if (row?.isNew === true) {
                  return prevData.filter((_, i) => i !== index);
                }

                return prevData;
              });
            }}
          >
            {<DeleteOutlineOutlinedIcon />}
          </button>
        </Tooltip>
      </>
    );
  };

  const renderInput = (row, index, header) => {
    const handleTableQuantityChange = (row, newValue) => {
      setInstrumentsData((prevData) =>
        prevData.map((item) =>
          item.ServiceId === row.ServiceId
            ? {
                ...item,
                Qty: Number(newValue),
                TotalAmt: (Number(newValue) * Number(item.Rate)).toFixed(2),
              }
            : item,
        ),
      );
    };

    return (
      <>
        {header === "Qty" && (
          <span>
            <input
              className={
                row.error !== true
                  ? "border border-gray-500 rounded w-24 px-2 focus:outline-none focus:border-2 focus:border-blue-500"
                  : "border-2 border-red-500 rounded w-24 px-2 focus:outline-none focus:border-red-500"
              }
              onChange={(e) => handleTableQuantityChange(row, e.target.value)}
              value={row["Qty"]}
              type="number"
              min="0"
              onWheel={(event) => event.currentTarget.blur()}
              onKeyDown={(e) => {
                if (
                  e?.key === "-" ||
                  e?.key === "+" ||
                  e?.code === "ArrowUp" ||
                  e?.code === "ArrowDown" ||
                  e?.code === "NumpadDecimal"
                ) {
                  e.preventDefault();
                }
              }}
              name={`Qty${[index]}`}
            />
          </span>
        )}
        {header === "ownInstrument" && (
          <Checkbox
            name={`ownInstrument${index}`}
            checked={row?.ownInstrument === true ? true : false}
            onChange={(e) => {
              let temp = [...instrumentsData];
              temp[index].ownInstrument = e.target.checked;
              setInstrumentsData(temp);
            }}
          />
        )}
      </>
    );
  };

  console.log("instrumentsData321", instrumentsData);

  //

  return (
    <>
      <div className=" text-gray-700 font-semibold whitespace-nowrap mb-2">
        Surgery Details
      </div>
      {/* ///Doctors List */}

      <div className="space-y-2">
        {/* //Group// */}
        <div className="grid grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-8 gap-3">
          <div className="col-span-2">
            <SearchDropdown
              name="searchService"
              placeholder="Search Service"
              dataArray={serviceInfo}
              handleInputChange={(e) => {
                setSearchString(e);
              }}
              searchIcon={true}
              error={errors.searchService}
              control={control}
              isClearable={true}
              inputRef={{
                ...register("searchService", {
                  onChange: (e) => {
                    if (e.target.value !== null) {
                      setValue("instServiceQty", 1);
                      setValue("instServiceRate", e?.target?.value?.Rate);
                      clearErrors(["instServiceQty"]);
                      clearErrors(["instServiceRate"]);
                    } else if (e.target.value === null) {
                      setValue("instServiceQty", "");
                      setValue("instServiceRate", "");
                    }
                  },
                }),
              }}
            />
          </div>
          <div>
            <InputField
              name="instServiceQty"
              variant="outlined"
              label="Quantity"
              error={errors.instServiceQty}
              control={control}
              inputProps={{ maxLength: 100 }}
            />
          </div>
          <div>
            <InputField
              name="instServiceRate"
              variant="outlined"
              label="Rate"
              error={errors.instServiceRate}
              control={control}
            />
          </div>
          <div className="flex space-x-2">
            <fieldset>
              <CheckBoxField
                control={control}
                name="ownInstrument"
                label="Doctor Own Instrument"
              />
            </fieldset>
            <CommonButton
              className="bg-customGreen text-white"
              label="Add"
              onClick={() => {
                if (
                  searchedServiceData !== null &&
                  searchedServiceData !== undefined &&
                  qty !== "" &&
                  qty !== undefined &&
                  getSelectedServiceRate !== "" &&
                  getSelectedServiceRate !== undefined
                ) {
                  addOtServices();
                  clearErrors([
                    "searchService",
                    "instServiceQty",
                    "instServiceRate",
                  ]);
                }
                if (
                  searchedServiceData === null ||
                  searchedServiceData === undefined
                ) {
                  setError("searchService", {
                    type: "custom",
                    message: "required",
                  });
                }
                if (qty === "" || qty === undefined) {
                  setError("instServiceQty", {
                    type: "custom",
                    message: "required",
                  });
                }
                if (
                  getSelectedServiceRate === "" ||
                  getSelectedServiceRate === undefined
                ) {
                  setError("instServiceRate", {
                    type: "custom",
                    message: "required",
                  });
                }
              }}
            />
          </div>
        </div>
        {/* table */}
        {instrumentsData.length > 0 &&
          instrumentsData &&
          instrumentsData.filter((item) => !item.isDelete).length > 0 && (
            <>
              <div className="w-full mt-2 col-span-12">
                <CommonDynamicTableNew
                  dataResult={instrumentsData
                    .filter((item) => !item.isDelete)
                    ?.map((val) => ({
                      ServiceId: val?.ServiceId,
                      "Service Name": val?.["Service Name"],
                      Rate: val?.Rate,
                      Qty: val?.Qty,
                      TotalAmt: val?.TotalAmt,
                      aneasAmount: val?.aneasAmount,
                      NetAmount: val?.NetAmount,
                      TariffId: val?.TariffId,
                      otOtherDetailsId: val?.otOtherDetailsId,
                      isDelete: val?.isDelete,
                      ownInstrument: val?.ownInstrument,
                      isNew: val?.isNew,
                    }))}
                  renderActions={renderActions}
                  renderInput={renderInput}
                  editableColumns={["Qty", "ownInstrument"]}
                  highlightRow={false}
                  removeHeaders={[
                    "id",
                    "otOtherDetailsId",
                    "TariffServiceId",
                    "ChargeId",
                    "ServiceId",
                    "aneasAmount",
                    "NetAmount",
                    "TariffId",
                    "otOtherDetailsId",
                    "isDelete",
                    "isNew",
                  ]}
                />
              </div>
            </>
          )}
      </div>

      {/* {!!sugeryEquipmentsData && sugeryEquipmentsData.length > 0 && (
        <>
          <div className=" text-gray-700 font-semibold whitespace-nowrap mt-3 mb-1">
            Equipment Details
          </div>

          <CommonDynamicTableNew
            dataResult={sugeryEquipmentsData}
            highlightRow={false}
            removeHeaders={["id", "ReservedEquipmentId"]}
          />
        </>
      )} */}

      <div className="mt-3">
        <InputArea
          name="intraOpExtraItemList"
          placeholder="Intra Operation Extra Item List"
          label="Intra Operation Extra Item List"
        />
      </div>
    </>
  );
};

export default Instruments;
